import React, { useState, useEffect, useContext, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import WishListIcon from "./wishListIcon";
import CartIcon from "./CartIcon";
import AuthContext from '../../context/AuthContext';
import PriceValue from "./PriceValue";
import "../../pages/StyleInventory/Jewellery.css";
import { Button } from 'primereact/button';
import { useFilters } from "../../context/JWFilterContext";
import { QuickView } from "../../api/GetJewellery";
//import { fetchCartCount, fetchWishlistCount } from "#common/fetchCartCount";

const responsiveClass = "card_box col-xl-3 col-lg-3 col-md-3 col-sm-6 col-sm-12 fade-in";
const DEFAULT_IMAGE = "/assets/images/VaultAccess/no-image3.png";

const Card = ({
    ringData,
    isLoading,
    loadingPageSize,
    showColorPalate,
    onUpdateWishlist,
    onUpdateCart,
    onTransfer,
    onRecentViewUpdate,
    onQuickViewOpen,
    onLoadMore,
    hasMore,
    Style_ID,
    handleAddToCart,
    fetchData,
    showCartIcon = true,
}) => {

    const { user } = useContext(AuthContext);
    const companyLogo = user?.COMPANYLOGO;
    const [loadedImages, setLoadedImages] = useState({});
    const [imageStatus, setImageStatus] = useState({});
    const [loadingQuickViewId, setLoadingQuickViewId] = useState(null);
    const isLoggedIn = user?.isAuthenticated;
    const navigate = useNavigate();
    const { clearAllFilters } = useFilters();

    const handleImageLoad = (id) => {
        setImageStatus(prev => ({ ...prev, [id]: "loaded" }));
    };

    const handleImageError = (id) => {
        setImageStatus(prev => ({ ...prev, [id]: "error" }));
    };

    // #region FOR CHECK LAST CARD VISIBILITY
    const lastItemRef = useRef(null);

    const handleQuickView = async (e, styleId, stockCategory = "STYLE") => {
        e.preventDefault();
        setLoadingQuickViewId(styleId);
        try {
            const request = {
                Style_ID: styleId,
                Customer_ID: user?.SelectedCustomer_ID,
                StockCategory: stockCategory,
            };

            const response = await QuickView(request);
            if (response && response.Row && response.Row.length > 0) {
                onQuickViewOpen(response.Row[0]);
            } else if (response?.Row) {
                onQuickViewOpen(response.Row[0]);
            }
        } catch (error) {
            console.error("Quick View Error:", error);
        } finally {
            setLoadingQuickViewId(null);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !isLoading) {
                    onLoadMore();
                }
            },
            { threshold: 1.0 }
        );

        if (lastItemRef.current) {
            observer.observe(lastItemRef.current);
        }

        return () => {
            if (lastItemRef.current) {
                observer.unobserve(lastItemRef.current);
            }
        };
    }, [ringData, hasMore, isLoading, onLoadMore]);
    // #endregion FOR CHECK LAST CARD VISIBILITY

    const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());

    const [isProcessing, setIsProcessing] = useState(false);

    return (
        <div className="card_sec">
            <div className="product-grid-layout">
                            {ringData && ringData.length > 0 && ringData.map((ring, index) => {
                                const queryParams = new URLSearchParams({
                                    style_ID: ring?.Style_ID
                                }).toString();

                                const isImageLoaded = loadedImages[ring.Style_ID];

                                return (
                                    <motion.div
                                        className="product-card"
                                        key={`${ring.Style_ID}-${index}`}
                                        ref={index === ringData.length - 1 ? lastItemRef : null}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        whileHover={{ scale: 1.02 }}
                                        transition={{ type: "spring", stiffness: 300 }}
                                    >
                                        <div className="product-image-wrapper">
                                            <div className="card-action-icons">
                                                <WishListIcon
                                                    onUpdateWishlistBasketID={onUpdateWishlist}
                                                    onTransfer={onTransfer}
                                                    Style_ID={ring.Style_ID}
                                                    JewelCode={ring.JewelCode}
                                                    StyleNo={ring.StyleNo}
                                                    Quantity={ring.Quantity}
                                                    Cart_ID={ring.Wishlist_ID}
                                                    iswishlist={isTrue(ring.IS_AddedInWishlist) ? "YES" : "NO"}
                                                    isincart={isTrue(ring.IS_AddedInCart) ? "YES" : "NO"}
                                                    ActualCart_ID={ring.Cart_ID}
                                                    fill="var(--text-primary)"
                                                    isProcessing={isProcessing}
                                                    setIsProcessing={setIsProcessing}
                                                />
                                                {showCartIcon && (
                                                    <CartIcon
                                                        onUpdateCart={onUpdateCart}
                                                        onTransfer={onTransfer}
                                                        Style_ID={ring.Style_ID}
                                                        JewelCode={ring.JewelCode}
                                                        StyleNo={ring.StyleNo}
                                                        Quantity={ring.Quantity}
                                                        isincart={isTrue(ring.IS_AddedInCart) ? "YES" : "NO"}
                                                        iswishlist={isTrue(ring.IS_AddedInWishlist) ? "YES" : "NO"}
                                                        Cart_ID={ring.Cart_ID}
                                                        fill="var(--text-primary)"
                                                        isProcessing={isProcessing}
                                                        setIsProcessing={setIsProcessing}
                                                    />
                                                )}
                                            </div>
                                            {ring?.NewArrivalStatus && <span className="badge badge-new">NEW</span>}
                                            {ring?.Status && <span className="badge badge-ready">{ring.Status}</span>}

                                            <NavLink to={`/detail?${queryParams}`}>
                                                <img
                                                    src={ring.Image1 || DEFAULT_IMAGE}
                                                    alt={ring?.StyleNo}
                                                    loading="lazy"
                                                    className={`product-image ${loadedImages[ring.Style_ID] ? "visible" : "loading"}`}
                                                    onLoad={() => setLoadedImages(prev => ({ ...prev, [ring.Style_ID]: true }))}
                                                    onError={(e) => {
                                                        e.target.src = DEFAULT_IMAGE;
                                                        setLoadedImages(prev => ({ ...prev, [ring.Style_ID]: true }));
                                                    }}
                                                />
                                                {!loadedImages[ring.Style_ID] && (
                                                    <div className="image-placeholder-shimmer" />
                                                )}
                                            </NavLink>
                                        </div>

                                        <div className="product-info">
                                            <div className="produc-amount-info">
                                                <div className="price-text">{ring?.LineAmount}</div>
                                                <Button
                                                    icon={loadingQuickViewId === ring.Style_ID ? "pi pi-spin pi-spinner" : "pi pi-eye"}
                                                    className="quick-view-btn"
                                                    onClick={(e) => handleQuickView(e, ring.Style_ID, "STYLE")}
                                                />
                                            </div>
                                            <div className="style-no">{ring?.Line1}</div>
                                            <div className="metal-detail">{ring?.Line2}</div>
                                        </div>
                                    </motion.div>
                                );
                            })}

                            {isLoading && (
                                <>
                                    {Array.from({ length: ringData.length > 0 ? 4 : 12 }).map((_, index) => (
                                        <div key={`skeleton-${index}`} className="product-card">
                                            <div className="product-image-wrapper">
                                                <Skeleton width="100%" height="230px" borderRadius="8px" />
                                            </div>
                                            <div className="product-info">
                                                <Skeleton width="60%" height="1rem" style={{ marginBottom: '3rem' }} />
                                                <Skeleton width="90%" height="1rem" style={{ marginBottom: '3rem' }} />
                                                <Skeleton width="70%" height="1rem" />
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}

                            {!isLoading && (!ringData || ringData.length === 0) && (
                                <div className="no-jewellery-found-premium">
                                    <div className="empty-state-visual">
                                        <img src="/assets/images/StockJewelley/JewelleryNotFound.gif" alt="No Jewellery Found" />
                                    </div>
                                    <div className="empty-state-content">
                                        <h2 className="empty-state-title">Oops!! No Jewellery Found</h2>
                                        <p className="empty-state-text">
                                            We couldn't find any items matching your current filters.
                                            Try adjusting your search or clear all filters to start over.
                                        </p>
                                        <button className="btn-primary" onClick={clearAllFilters}>
                                            <i className="pi pi-filter-slash me-2" />
                                            Clear All Filters
                                        </button>
                                    </div>
                                </div>
                            )}
            </div>
        </div>
    );
};


Card.propTypes = {
    ringData: PropTypes.arrayOf(
        PropTypes.shape({
            Rno: PropTypes.number.isRequired,
            Style_ID: PropTypes.string.isRequired,
            StyleNo: PropTypes.string.isRequired,
            IMAGEPATH: PropTypes.string,

            TotalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            JwlFinalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

            SearchByTag: PropTypes.string,
            ProductCategoryName: PropTypes.string,
            ProductCategory_ID: PropTypes.number,

            DiamondManufacturingType: PropTypes.string,
            DiamondManufacturingType_ID: PropTypes.number,

            GoldAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            GoldColor: PropTypes.string,
            GoldColorName: PropTypes.string,
            GoldColor_ID: PropTypes.number,
            GoldKtName: PropTypes.string,
            GoldQuality_ID: PropTypes.number,
            GoldWeight: PropTypes.number,

            WhiteDiamondQualityName1: PropTypes.string,
            WhiteDiamondQuality_ID1: PropTypes.number,
            WhiteDiamondShapeName1: PropTypes.string,
            WhiteDiamondShape_ID1: PropTypes.number,

            ProductSubCategoryName: PropTypes.string,
            ProductSubCategory_ID: PropTypes.number,
            ProductSize_ID: PropTypes.number,

            NewArrivals: PropTypes.string,
            Bestsellers: PropTypes.string,
            IsCart: PropTypes.number,
            IsWishlist: PropTypes.number,
            WishlistBasket_ID: PropTypes.string,
            Sku: PropTypes.string,
        })
    ).isRequired,

    isLoading: PropTypes.bool,
    loadingPageSize: PropTypes.number,
    showColorPalate: PropTypes.bool,

    onUpdateWishlist: PropTypes.func,
    onRecentViewUpdate: PropTypes.func,
    onLoadMore: PropTypes.func,
    hasMore: PropTypes.bool,
};

export default Card;